import React, { FC } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { getUrl, Analytics } from "../../utilities";
import "./Footer.scss";

interface FooterProps {
  menu?: string;
}

type FooterLink = {
  label: string;
  path: string;
}

const footerLinks: FooterLink[] = [
  { label: "About BBC Player", path: "about" },
  { label: "Help & Support", path: "help-and-support" },
  { label: "Terms & Conditions", path: "terms-and-conditions" },
];

const Footer: FC<FooterProps> = ({ menu }) => {
  const handleClick = (label: string, path: string) => {
    Analytics.userActionNavigation(
      label,
      path,
      {
        context: "footer",
        groupType: "footer",
        sectionName: path
      }
    );
  };

  return (
    <div className={classnames("Footer", { menu })}>
      <div className="Footer__content">
        {footerLinks.map(({ label, path }) => (
          <div key={path} className="Footer__item">
            <Link
              to={getUrl(path)}
              onClick={() => handleClick(label, path)}
            >
              {label}
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
};

export default Footer;
